import store from '@/store';

const routes = [
  {
    path: '/settings/reviews',
    name: 'ReviewsPage',
    component: () => import(/* webpackChunkName: "ReviewsPage" */ './views/ReviewsPage.vue'),
    meta: { i18n: 'reviews-pov' },
    beforeEnter: (to, from, next) => {
      const hasPermission = store.getters['StaffStore/hasPermission']('can_access_settings');
      const hasCollectReviewsFF = store.getters['BusinessStore/hasFeature']('collect_reviews');
      if (hasCollectReviewsFF && hasPermission) {
        next();
      } else {
        next('/');
      }
    },
  },
];

export default routes;
